import React from 'react';
import { OrderPage } from '../../src/pages/order';

function OrderFinance() {
  return <OrderPage />;
}

export default OrderFinance;
